import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Typography } from '@mui/material';
import useAuthStore from '../shared/store/useAuthStore';
import {
ssoApiUrl,
ssoClientId,
ssoClientSecret,
} from '../shared/constants';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import { fetchData as fetchDataNode } from "../assets/nodeApi/fetchData";
// import { setCookie } from '../shared/utils/CookieUtils';


const CallbackPage = () => {
const location = useLocation();
const navigate = useNavigate();
const login = useAuthStore((state) => state.login);
const queryClient = useQueryClient()


const handleSSOLogin = useCallback(
  async (code) => {
    try {
      const response = await axios.post(
        ssoApiUrl,
        {
          code,
          client_id: ssoClientId,
          client_secret: ssoClientSecret,
        },
        {
          withCredentials: true,
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // console.log('SSO Login Response:', response.data);
      
      // setCookie('refresh_token_f', response.data?.refresh_token, 7); 

      const accessToken =
        response.data?.data?.token ||
        response.data?.token ||
        response.data?.accessToken ||
        response.data?.data?.accessToken ||
        'sso_active';

      const user =
        response.data?.data?.user ||
        response.data?.user ||
        response.data?.data ||
        response.data;

      login(user, accessToken);

      queryClient.prefetchQuery({
        queryKey: ["user-info"],
        queryFn: () => fetchDataNode("details"),
      });
      queryClient.removeQueries({ queryKey: ["courses"], exact: false });
      queryClient.refetchQueries({ queryKey: ["courses"], exact: false });
      const storedPath = localStorage.getItem("lastVisitedPath") || "/";
      const storedCourseId = localStorage.getItem("lastVisitedCourseId") || "/";

      return;
    } catch (error) {
      console.error('SSO Login Error:', error);

      const errorData =
        error.response?.data?.data || error.response?.data;

      const ssoUser = errorData?.ssoUser || errorData;
    }
  },
  [login, navigate]
);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const code = params.get('code');

  if (code) {
    handleSSOLogin(code);
  } else {
    toast.error('Authorization code missing');
  }
}, [location.search, handleSSOLogin, navigate]);

return (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    height="100vh"
  >
    <CircularProgress size={60} />
    <Typography variant="h6" mt={2}>
      Processing SSO Login...
    </Typography>
  </Box>
);
};

export default CallbackPage;